import { VisitPrintsPatientSendCommand, VisitPrintsPatientSendResult } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor } from '@dreryk/react-components';

import {
   MedicalDocumentationShareFormBean,
   MedicalDocumentationShareFormSubmitHandler,
} from '~libs.desktop.shared.medical-documentation';

import { Prints } from './form/PrintsForm.types';
import { translationKeys } from './translations';

type PrintsPatientSendEventInterceptorRenderProps = {
   filePassword: string | null;
};

type PrintsPatientSendEventInterceptorProps = Readonly<{
   children: (renderProps: PrintsPatientSendEventInterceptorRenderProps) => JSX.Element;
   visitId: number;
   onMedicalDocumentationShareFormSubmit: MedicalDocumentationShareFormSubmitHandler;
   prints: Prints;
}>;

export const PrintsPatientSendEventInterceptor = (props: PrintsPatientSendEventInterceptorProps): JSX.Element => {
   const { executeAsync: sendPatientPrints, data } = useCqrsCommand<
      VisitPrintsPatientSendResult,
      MedicalDocumentationShareFormBean
   >((parameters) => {
      const command = new VisitPrintsPatientSendCommand();
      command.visitId = props.visitId;

      command.prints = {
         otherDocuments: props.prints.otherDocuments,
         physicalExamination: props.prints.subjectiveAssessment,
         recommendations: props.prints.recommendations,
         summary: props.prints.summary,
      };

      command.contact = {
         phoneNumber: parameters.phoneNumber!,
         emailAddress: parameters.emailAddress!,
      };

      return command;
   });

   return (
      <ActionEventInterceptor
         action={props.onMedicalDocumentationShareFormSubmit(sendPatientPrints)}
         blockingOperation={translationKeys.sharingDocumentation}
      >
         {props.children({ filePassword: data?.password ?? null })}
      </ActionEventInterceptor>
   );
};
